/* サパれる！ 料金データ（単一の真実 / 商品ページ・トップ簡易見積もり 共通）
   2026-06-29 価格改定: シルクスクリーン値上げ＋フルカラーDTF導入＋自動最安判定 */
window.PRICING = {
  plateUnit: 5500,        // 版代（初回のみ・1色=1版あたり / 28×40以内）
  shippingFree: 33000,
  shippingFee: 800,
  foldPerPiece: 50,
  namePerPiece: 1340,
  /* カートに料金を反映するための内部「加工費」商品 variant（単価¥1／数量=金額）。
     管理画面: オリジナルプリント加工費 (handle: internal-print-fee) */
  feeVariantId: 51369220997435,

  /* シルクスクリーン: プリント代（1色目=print / 追加1色ごと=up）。1〜4枚は注文一律の定額。 */
  tiers: [
    { min: 1,   max: 4,   print: null, printFlat: 1680, upFlat: 945 },
    { min: 5,   max: 19,  print: 315,  up: 155 },
    { min: 20,  max: 49,  print: 250,  up: 95  },
    { min: 50,  max: 99,  print: 160,  up: 75  },
    { min: 100, max: 199, print: 125,  up: 65  },
    { min: 200, max: 499, print: 105,  up: 40  },
    { min: 500, max: 999, print: 95,   up: 30  }
  ],

  /* フルカラーDTF: 色数に関係なく1枚あたり定額（版代なし）。枚数帯で単価が下がる。 */
  dtfTiers: [
    { min: 1,   max: 1,   unit: 2500 },
    { min: 2,   max: 5,   unit: 2100 },
    { min: 6,   max: 10,  unit: 1900 },
    { min: 11,  max: 30,  unit: 1780 },
    { min: 31,  max: 50,  unit: 1550 },
    { min: 51,  max: 999, unit: 1280 }
  ]
};

window.PRICING.findTier = function(qty) {
  var q = Math.max(1, Math.min(999, qty|0));
  for (var i=0; i<this.tiers.length; i++) if (q>=this.tiers[i].min && q<=this.tiers[i].max) return this.tiers[i];
  return this.tiers[this.tiers.length-1];
};

window.PRICING.dtfUnit = function(qty) {
  var q = Math.max(1, Math.min(999, qty|0));
  for (var i=0; i<this.dtfTiers.length; i++) if (q>=this.dtfTiers[i].min && q<=this.dtfTiers[i].max) return this.dtfTiers[i].unit;
  return this.dtfTiers[this.dtfTiers.length-1].unit;
};

/* シルクスクリーンのプリント代（版代を除く・色×枚数）を算出 */
window.PRICING.silkPrint = function(qty, plates) {
  if (qty <= 0) return 0;
  var tier = this.findTier(qty);
  var extra = Math.max(0, plates - 1);
  if (tier.printFlat != null) return tier.printFlat + tier.upFlat * extra;       // 1〜4枚=注文一律
  return (tier.print + tier.up * extra) * qty;
};

/* 箇所ごとにシルク vs DTF を判定して合算する（DTF×シルク併用対応）。
   locColors = 各箇所の色数の配列（例 [3,1]）。9色以上の箇所は必ずDTF。
   シルクの1色目単価(print)は最初のシルク箇所のみに適用し、2箇所目以降のシルク箇所は
   追加色単価(up)で全色を加算（従来の全体計算＝plates合算と同じ積み上げ方）。
   版代はシルク箇所の色数×5,500のみ（DTF箇所は版なし）。
   戻り値: { method:'silk'|'dtf'|'mix', label, printTotal, plateTotal, dtfUnit,
             silkPlates, locMethods:[{colors, method}] } */
window.PRICING.quotePrintByLocation = function(opts) {
  var qty = Math.max(0, opts.qty|0);
  var locColors = (opts.locColors && opts.locColors.length)
    ? opts.locColors.map(function(c){ return Math.max(1, c|0); })
    : [Math.max(1, opts.plates|0)];
  var isAdditional = !!opts.isAdditional;
  var plateMult = opts.plateMult || 1;
  if (qty <= 0) return { method:'silk', label:'シルクスクリーン', printTotal:0, plateTotal:0, dtfUnit:0, silkPlates:0, locMethods:[] };

  var tier = this.findTier(qty);
  var dtfUnit = this.dtfUnit(qty);
  var dtfPerLoc = dtfUnit * qty;   // DTFはこの箇所1転写あたりの費用（版代なし）
  var printTotal = 0, plateTotal = 0, silkPlates = 0;
  var locMethods = [];
  var hasSilk = false;

  for (var i = 0; i < locColors.length; i++) {
    var c = locColors[i];
    var fullColor = c >= 9;
    // この箇所をシルクにした場合のプリント代（1色目単価は最初のシルク箇所のみ）
    var silkPrint;
    if (tier.printFlat != null) {
      silkPrint = hasSilk ? (tier.upFlat * c) : (tier.printFlat + tier.upFlat * (c - 1));
    } else {
      silkPrint = (hasSilk ? (tier.up * c) : (tier.print + tier.up * (c - 1))) * qty;
    }
    var silkPlate = isAdditional ? 0 : this.plateUnit * c * plateMult;
    var useDtf = fullColor || (dtfPerLoc < silkPrint + silkPlate);
    if (useDtf) {
      printTotal += dtfPerLoc;
      locMethods.push({ colors: c, method: 'dtf' });
    } else {
      printTotal += silkPrint;
      plateTotal += silkPlate;
      silkPlates += c;
      hasSilk = true;
      locMethods.push({ colors: c, method: 'silk' });
    }
  }

  var anyDtf = false, anySilk = false;
  locMethods.forEach(function(m){ if (m.method === 'dtf') anyDtf = true; else anySilk = true; });
  var method = (anyDtf && anySilk) ? 'mix' : (anyDtf ? 'dtf' : 'silk');
  var label = method === 'mix' ? 'シルク＋DTF併用' : (method === 'dtf' ? 'DTFプリント' : 'シルクスクリーン');
  return { method:method, label:label, printTotal:printTotal, plateTotal:plateTotal,
    dtfUnit:dtfUnit, silkPlates:silkPlates, locMethods:locMethods };
};

/* シルク vs DTF を比較し、最安のプリント手法を返す。
   plates = 総版数（=各箇所の色数合計）, positions = プリント箇所数, fullColor = 9色以上/フルカラー指定。
   戻り値: { method:'silk'|'dtf', label, printTotal, plateTotal, dtfUnit }
   ・printTotal は「プリント代」、plateTotal は「版代」（DTFは版代0）。
   ・isAdditional（追加注文）時はシルクの版代を0として比較。 */
window.PRICING.quotePrint = function(opts) {
  var qty = Math.max(0, opts.qty|0);
  var plates = Math.max(1, opts.plates|0);
  var positions = Math.max(1, opts.positions|0);
  var isAdditional = !!opts.isAdditional;
  var fullColor = !!opts.fullColor;
  var plateMult = opts.plateMult || 1;
  if (qty <= 0) return { method:'silk', label:'シルクスクリーン', printTotal:0, plateTotal:0, dtfUnit:0 };

  // シルク
  var silkPrint = this.silkPrint(qty, plates);
  var silkPlate = isAdditional ? 0 : this.plateUnit * plates * plateMult;
  var silkCost  = silkPrint + silkPlate;

  // DTF（フルカラー・版代なし・箇所ごとに1転写）
  var dtfUnit  = this.dtfUnit(qty);
  var dtfPrint = dtfUnit * qty * positions;

  // 9色以上(フルカラー)はシルク価格を持たないため常にDTF。それ以外は安い方を採用。
  var useDtf = fullColor || (dtfPrint < silkCost);
  if (useDtf) {
    return { method:'dtf', label:'DTFプリント', printTotal:dtfPrint, plateTotal:0, dtfUnit:dtfUnit };
  }
  return { method:'silk', label:'シルクスクリーン', printTotal:silkPrint, plateTotal:silkPlate, dtfUnit:dtfUnit };
};
